import Vue from 'vue'
import Router from 'vue-router'

import DefaultLayout from '@/views/Layouts/default.vue'
import HomePage from '@/views/Home/index.vue'
import AboutPage from '@/views/About/index.vue'
import UserInfoPage from '@/views/User/index.vue'
import Error404Page from '@/views/Errors/404.vue'
import EulaPage from '@/views/LegalPolicies/Eula.vue'
import News from '@/views/News/index.vue'
import Messanger from '@/views/Messanger/index.vue'
import Team from '@/views/Team/index.vue'
import Faq from '@/views/Faq/index.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: DefaultLayout,
    meta: {
      auth: true,
      bodyClass: 'app'
    },
    children: [
      { path: '/', name: 'home', component: HomePage, meta: { bodyClass: 'home-page' } },
      { path: '/about', name: 'about', component: AboutPage, meta: { bodyClass: 'about-page' } },
      { path: '/user-info', name: 'user', component: UserInfoPage, meta: { bodyClass: 'user-page' } },
      { path: '/news', name: 'news', component: News, meta: { bodyClass: 'news' } },
      { path: '/messenger', name: 'messenger', component: Messanger, meta: { bodyClass: 'messenger' } },
      { path: '/eula', name: 'eula', component: EulaPage, meta: { bodyClass: 'eula-page' } },
      { path: '/team', name: 'team', component: Team, meta: { bodyClass: 'team-page' } },
      { path: '/faq', name: 'faq', component: Faq, meta: { bodyClass: 'faq-page' } }
    ]
  },
  { path: '*', component: Error404Page, meta: { bodyClass: 'error404-page' } }
]

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
